import "../../global.css";
import "./customer.css";
import { useEffect, useState } from "react";
import {
  publicRequest,
  userRequest,
  resolveUrlMooda,
  whatsAppCall,
} from "../../requestMethods";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/loading";
import { useCompany } from "../../components/context/CompanyContext";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Container from "@mui/material/Container";
import Switch from "@mui/material/Switch";
import {
  formatPricing,
  formatPricingDatabase,
  shareUrl,
  validarEmail,
  validarCPF,
  validarCpfCnpj,
} from "../../util/helper";
export default function User() {
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const [data, setData] = useState({});
  const [inputs, setInputs] = useState({});
  const [states, setStates] = useState([]);
  const [users, setUsers] = useState([]);
  const [state, setState] = useState();
  const [managedBy, setManagedBy] = useState();
  const [oldManagedBy, setOldManagedBy] = useState();
  const [managed, setManaged] = useState();
  const [userRepId, setUserRepId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [activeIni, setActiveIni] = useState(false);
  const [active, setActive] = useState("Pendente");
  const { companyId, companyName, slug, showPrice, isRetail } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const nav = useNavigate();
  const [address, setAddress] = useState();
  const [rzSocial, setRzSocial] = useState();
  const [mainActivity, setMainActivity] = useState();
  const [registerState, setRegisterState] = useState();
  const [cnpj_cpf, setCnpj_cpf] = useState();
  const [contact, setContact] = useState();
  const [rejections, setRejections] = useState([]);
  const [reason, setReason] = useState();
  const [numAddress, setNumAddress] = useState();
  const [complement, setComplement] = useState();
  const [estrangeiro, setEstrangeiro] = useState();
  const [target, setTarget] = useState();
  const [campaign, setCampaign] = useState();
  const [campaigns, setCampaigns] = useState();
  const [premium, setPremium] = useState(false);
  const [reps, setReps] = useState([]);

  const _findManaged = (value) => {
    let nameManager = users.find(
      (usr) => usr.userId.toString() === value.toString(),
    );

    return nameManager;
  };
  useEffect(() => {
    if (data) {
      if (data.address) {
        setAddress(data.address);
        setState(data.address.state);
        setNumAddress(data.address.numAddress);
        setComplement(data.address.complement);
      }
      if (data.name) {
        setInputs((prev) => ({ ...prev, name: data.name }));
      }
      if (data.email) {
        setInputs((prev) => ({ ...prev, email: data.email }));
      }
      if (data.owner_cpf) {
        setInputs((prev) => ({ ...prev, owner_cpf: data.owner_cpf }));
      }
      if (data.onlineStore) {
        setInputs((prev) => ({ ...prev, onlineStore: data.onlineStore }));
      }
      if (data.userRepId) {
        setUserRepId(data.userRepId);
      }
      if (data.managedBy) {
        setManagedBy(data.managedById);
        setOldManagedBy(data.managedById);
        setManaged({
          contact: data.contactManagedBy,
          name: data.managedBy,
          userId: data.managedById,
        });
      }
      if (data.enabled) {
        setActive(data.enabled);
        if (data.enabled === "Aprovado") {
          setActiveIni(true);
        }
      }
      if (data.rzSocial) {
        setRzSocial(data.rzSocial);
      }
      if (data.mainActivity) {
        setMainActivity(data.mainActivity);
      }
      setRegisterState(data.registerState || "");
      if (data.contact) {
        setContact(data.contact);
      }
      if (data.customerRejectionId) {
        setReason(data.customerRejectionId);
      }
      if (data.foreigner) {
        setEstrangeiro(true);
      }
      if (data.campaignId) {
        setPremium(true);
      } else {
        setPremium(false);
      }

      if (data.target && data.campaignId) {
        setTarget(data.target);
        setCampaign(data.campaignId);
      }
    }
  }, [data]);

  useEffect(() => {
    if (companyId > 0) {
      getStates();
      getManager();
      getReason();
      getReps();
      getAllCompaign();
    }

    if (id !== "new") {
      getCustomers();
    }
  }, [id, companyId]);

  const getReps = async () => {
    try {
      const res = await userRequest.get(`${companyId}/usersRep/active`);

      setReps(res.data);
    } catch {
      console.log();
    }
  };
  const getCustomers = async () => {
    try {
      const res = await userRequest.get(`${companyId}/customers/find/${id}`);
      res.data.map((item) => {
        setData(item);
      });
    } catch {
      console.error();
    }
  };

  const getStates = async () => {
    const res = await userRequest.get(`${companyId}/customers/state`);

    setStates(res.data);
  };
  const getManager = async () => {
    const res = await userRequest.get(`${companyId}/users`);

    setUsers(
      res.data.filter(
        (item) =>
          item.position === "Vendedor(a)" &&
          (item.deleted === null || item.deleted === undefined),
      ),
    );
  };
  const getReason = async () => {
    const res = await userRequest.get(`${companyId}/customerRejections`);

    setRejections(res.data);
  };
  const getAllCompaign = async () => {
    const res = await userRequest.get(`${companyId}/campaign/active`);

    setCampaigns(res.data);
  };
  const validadeVen = () => {
    if (
      currentUser.isAdmin &&
      active &&
      (managedBy === "" || managedBy === undefined)
    ) {
      Swal.fire("Atenção!", "Vendedor(a) não selecionado.", "warning");
      return false;
    }

    if (target && !campaign) {
      Swal.fire(
        "Atenção!",
        "O campo Campanha deve ser selecionado.",
        "warning",
      );
      return false;
    }

    if (!target && campaign) {
      Swal.fire(
        "Atenção!",
        "O campo Meta de Compra deve ser preechido.",
        "warning",
      );
      return false;
    }

    if (active === "Negado" && !reason) {
      Swal.fire(
        "Atenção!",
        "O campo Motivo do Negado deve ser selecionado.",
        "warning",
      );
      return false;
    }
    return true;
  };
  const validate = () => {
    if (inputs.name === "" || inputs.name === undefined) {
      Swal.fire("Atenção!", "O campo Nome deve ser preenchido.", "warning");
      return false;
    }
    // if (inputs.password === "" || inputs.password === undefined) {
    //   Swal.fire("Atenção!", "O campo Senha deve ser preenchido.", "warning");
    //   return false;
    // }
    if (
      (inputs.owner_cpf === "" || inputs.owner_cpf === undefined) &&
      (cnpj_cpf === "" || cnpj_cpf === undefined)
    ) {
      Swal.fire(
        "Atenção!",
        "O campo CPF do proprietário ou CNPJ são obrigátorios.",
        "warning",
      );
      return false;
    }

    if (
      (inputs.owner_cpf !== "" || inputs.owner_cpf !== undefined) &&
      (cnpj_cpf === "" || cnpj_cpf === undefined) &&
      (inputs.onlineStore === "" || inputs.onlineStore === undefined)
    ) {
      Swal.fire(
        "Atenção!",
        "O campo Instagram ou Loja Virtual é obrigátorios.",
        "warning",
      );
      return false;
    }

    /*if (cnpj_cpf === "" || cnpj_cpf === undefined) {
      Swal.fire("Atenção!", "O campo CNPJ deve ser preenchido.", "warning");
      return false;
    }
    if (inputs.owner_cpf === "" || inputs.owner_cpf === undefined) {
      Swal.fire(
        "Atenção!",
        "O campo CPF do Proprietário deve ser preenchido.",
        "warning"
      );
      return false;
    }

    if (!rzSocial || rzSocial === "" || rzSocial === undefined) {
      Swal.fire(
        "Atenção!",
        "O campo Razão Social deve ser preenchido.",
        "warning"
      );
      return false;
    }
    */
    if (inputs.owner_cpf && !validarCPF(inputs.owner_cpf)) {
      Swal.fire("Atenção!", "CPF do proprietário inválido.", "warning");
      return false;
    }
    if (cnpj_cpf && !validarCpfCnpj(cnpj_cpf)) {
      Swal.fire("Atenção!", "CPF/CNPJ inválido.", "warning");
      return false;
    }
    if (contact === "" || contact === undefined) {
      Swal.fire("Atenção!", "O campo Telefone deve ser preenchido.", "warning");
      return false;
    }
    if (inputs.email === "" || inputs.email === undefined) {
      Swal.fire("Atenção!", "O campo Email deve ser preenchido.", "warning");
      return false;
    }
    if (!validarEmail(inputs.email)) {
      Swal.fire("Atenção!", "E-mail inválido.", "warning");
      return false;
    }
    if (!address || address.street === "" || address.street === undefined) {
      Swal.fire("Atenção!", "O campo Endereço deve ser preenchido.", "warning");
      return false;
    }
    if (!address || address.cep === "" || address.cep === undefined) {
      Swal.fire("Atenção!", "O campo CEP deve ser preenchido.", "warning");
      return false;
    }
    if (!address || address.state === "" || address.state === undefined) {
      Swal.fire("Atenção!", "O campo Estado deve ser selecionado.", "warning");
      return false;
    }

    return true;
  };
  const updateClick = async (event) => {
    setIsLoading(true);

    if (id !== "new") {
      if (validadeVen()) {
        Update();
      }
    } else {
      if (validate()) {
        if (validadeVen()) {
          Inserir();
        }
      }
    }
    setIsLoading(false);
  };
  async function alteraPedidos(customerId) {
    if (!managedBy) {
      return;
    }

    if (oldManagedBy && parseInt(managedBy) === parseInt(oldManagedBy)) {
      return;
    }

    if (parseInt(managedBy) !== parseInt(oldManagedBy)) {
      const res = await userRequest.post(`${companyId}/orders/customer`, {
        newManaged: parseInt(managedBy),
        oldManaged: parseInt(oldManagedBy),
        customerId: customerId,
      });
    }
  }
  const ObjCustomer = () => {
    return {
      name: inputs.name,
      //password: inputs.password,
      cnpj_cpf: cnpj_cpf,
      rzSocial: rzSocial,
      contact: contact,
      email: inputs.email ? inputs.email : null,
      owner_cpf: inputs.owner_cpf,
      managedBy: managedBy ? managedBy : currentUser.userId,
      enabled: active,
      customerRejectionId: reason,
      lastUserUpdate: currentUser.userId,
      onlineStore: inputs.onlineStore,
      address: {
        street: inputs.street !== undefined ? inputs.street : address?.street,
        numAddress: numAddress,
        complement: complement,
        cep: address?.cep,
        state: address?.state,
        district: address?.district,
        city: address?.city,
      },
      mainActivity: mainActivity,
      registerState: registerState,
      foreigner: estrangeiro,
      //presales: premium,
      target: { target: target, campaignId: campaign },
      userRepId: userRepId,
    };
  };
  const Update = async (event) => {
    try {
      const res = await userRequest.put(
        `${companyId}/customers/${id}`,
        ObjCustomer(),
      );
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Cliente alterado com sucesso!", "success");
        smsSend();
        alteraPedidos(id);
        nav(`../customers`);
      } else {
        Swal.fire("Atenção!", "Erro ao alterar cliente!", "error");
      }
    } catch (error) {}
  };
  const _findRejection = (customerRejectionId) => {
    if (customerRejectionId) {
      const reject = rejections.find(
        (item) =>
          item.customerRejectionId.toString() ===
          customerRejectionId.toString(),
      );

      if (reject !== undefined) {
        return reject;
      } else {
        return null;
      }
    }
    return null;
  };
  const smsSend = async () => {
    let sms = {
      userId: managedBy ? managedBy : currentUser.userId,
      customerId: data.customerId,
    };
    let sms2 = {
      userId: managedBy ? managedBy : currentUser.userId,
      customerId: data.customerId,
    };
    let obj = {};
    let objVend = {};
    let rejection = _findRejection(reason);

    if (currentUser.isAdmin && active === "Aprovado" && !activeIni) {
      obj = {
        contact: contact,
        message:
          "*PARABÉNS!*\u{1F389}\nSeu cadastro já está liberado para acessar nossos preços!\u{1F680}\nClique agora no link, clique em ver preços, digite novamente seu telefone para receber o código de liberação e valide seu acesso: " +
          resolveUrlMooda(isRetail, slug) +
          "home" +
          " Nossa vendedor(a) " +
          managed.name +
          " irá atender você.",
      };

      sms.message = `Oi, *${data.name?.split(" ")[0]}*, tudo bem?
      \rMe chamo *${
        managed.name
      }*, sou responsável pelo atendimento aqui na ${companyName}.
      \rSeu cadastro já foi aprovado! *Agora você já consegue acessar os preços no nosso catálogo digital. Para isso basta seguir os passos abaixo:*\r\n
      \u{25CF} Clique no link ${shareUrl(slug, isRetail)}
      \u{25CF} Clique em *Ver os Preços*
      \u{25CF} Adicionar o número de celular utilizado no seu cadastro.`;
        sms2.message = `Fique à vontade para conhecer nossos modelos e conferir as opções disponíveis. Se algum produto chamar sua atenção, é só me passar a referência por aqui.\r\n
                Se precisar, posso te ajudar com as opções e na montagem do seu pedido.\u{1F4AD}`;
      objVend = {
        contact: managed.contact,
        message:
          "*CLIENTE APROVADO*\u{1F6CD}\nO cliente " +
          data.name +
          " já está aprovado!\nContate agora mesmo!\n" +
          whatsAppCall +
          contact,

        //serviceType: "short",
      };

      if (!showPrice) {
        const res = userRequest.post(`${companyId}/bot/sendMsg`, sms);
      }
      const res2 = userRequest.post(`${companyId}/bot/sendMsg`, sms2);

      //const resV = userRequest.post(`${companyId}/bot/sendSMS`, objVend);
      //pushnotification vendedor
      let objVendPush = {
        title: "Cliente Aprovado",
        body:
          "O cliente " + data.name + " já está aprovado! Contate agora mesmo!",
        url: whatsAppCall + contact,
      };
      const push = userRequest.post(
        `${companyId}/push/send/user/${managed.userId}`,
        objVendPush,
      );
    }
    if (
      (currentUser.isAdmin && active === "Negado") ||
      (active === "Negado" && !activeIni && currentUser.isAdmin)
    ) {
      obj = {
        contact: contact,
        message:
          companyName +
          ":Infelizmente seu cadastro foi negado pelo seguite motivo:" +
          rejection.rejection +
          ".\u{1F625}",
        //serviceType: "short",
      };
      const res = await userRequest.post(`${companyId}/bot/sendSMS`, obj);
    }
  };

  const Inserir = async () => {
    try {
      const res = await userRequest.post(
        `${companyId}/customers/registerCustomer`,
        [ObjCustomer()],
      );

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Cliente inserido com sucesso!", "success");
        smsSend();
        nav(`../customers`);
      } else {
        Swal.fire("Atenção!", "Erro ao inserir cliente!", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const handleChangeContact = (e) => {
    setContact(e.target.value);
  };
  const handleChangeNumAddress = (e) => {
    setNumAddress(e.target.value);
  };
  const handleChangeComplement = (e) => {
    setComplement(e.target.value);
  };
  const handleChangeRz = (e) => {
    setRzSocial(e.target.value);
  };
  const handleChangeState = (e) => {
    setState(e.target.value);
  };
  const handleChangeManager = (e) => {
    setManagedBy(e.target.value);

    setManaged(_findManaged(e.target.value));
  };
  const handleChangeRep = (e) => {
    setUserRepId(e.target.value);

    setManaged(_findManaged(e.target.value));
  };
  const handleChangeCampaign = (e) => {
    setCampaign(e.target.value);
  };
  const handleChangeActive = (e) => {
    setActive(e.target.value);
  };

  const handleChangeTarget = (e) => {
    setTarget(e.target.value);
  };
  const handleChangeReason = (e) => {
    setReason(e.target.value);
  };
  const handleChangeCEP = (e) => {
    const val = e.target.value.replace("-", "");
    setAddress((prev) => ({ ...prev, cep: val }));
    if (val.length === 8) {
      getCep(val);
    }
  };
  const handleChangeCNPJ = (e) => {
    if (e.target.value.length >= 13) {
      getCNPJ(e.target.value.trim());
    }
  };

  const getCep = async (cep) => {
    cep = cep.trim().replace("-", "");
    const res = await userRequest.get(`${companyId}/customers/cep/${cep}`);

    setAddress({
      street: res.data.logradouro,
      complement: res.data.complement,
      cep: res.data.cep,
      state: res.data.uf,
      district: res.data.bairro,
      city: res.data.localidade,
    });
  };
  const getCNPJ = async (cnpj) => {
    const res = await userRequest.get(`${companyId}/customers/cnpj/${cnpj}`);

    if (res.data && Object.keys(res.data).length > 0) {
      setRzSocial(res.data.razao_social);
      setMainActivity(res.data.atividadePrincipal);
      setRegisterState(res.data.inscricao_estadual);
      setNumAddress(res.data.end_num_empresa);
      setComplement(res.data.end_comp_empresa);
      setInputs((prev) => ({ ...prev, name: res.data.socio }));
      setAddress({
        cep: res.data.end_cep,
        street: res.data.end_empresa,
        district: res.data.end_bairro,
        city: res.data.end_cidade,
        state: res.data.end_estado,
      });
    }
    setCnpj_cpf(cnpj);
  };
  const handleChangeEstrangeiro = (e) => {
    //setAdmin(e.target.value);
    setEstrangeiro(e.target.checked);
  };
  const handleChangeEnabled = (e) => {
    setPremium(e.target.checked);
  };
  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="cust-page">
          <div className="cust-title">
            {id !== "new" ? "Editar Cliente" : "Novo Cliente"}
          </div>

          {/* Contato */}
          <div className="cust-card">
            <div className="cust-section-header">Dados de Contato</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Telefone</label>
                <input
                  type="text"
                  name="contact"
                  onChange={handleChangeContact}
                  className="cust-input"
                  defaultValue={id !== "new" ? contact || "" : ""}
                  maxLength="12"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Nome do Proprietário</label>
                <input
                  type="text"
                  name="name"
                  value={inputs.name || ""}
                  className="cust-input"
                  onChange={handleChange}
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="cust-input"
                  defaultValue={id !== "new" ? data.email || "" : ""}
                  onChange={handleChange}
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Instagram ou Loja Virtual</label>
                <input
                  type="text"
                  name="onlineStore"
                  className="cust-input"
                  defaultValue={id !== "new" ? data.onlineStore || "" : ""}
                  onChange={handleChange}
                  maxLength="200"
                />
              </div>
            </div>
          </div>

          {/* Fiscal */}
          <div className="cust-card">
            <div className="cust-section-header">Dados Fiscais</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">CPF do Proprietário</label>
                <input
                  type="text"
                  pattern="\d*"
                  name="owner_cpf"
                  className="cust-input"
                  defaultValue={id !== "new" ? data.owner_cpf || "" : ""}
                  onChange={handleChange}
                  maxLength="14"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">CNPJ</label>
                <input
                  type="text"
                  pattern="\d*"
                  name="cnpj_cpf"
                  className="cust-input"
                  defaultValue={id !== "new" ? data.cnpj_cpf || "" : ""}
                  onChange={handleChangeCNPJ}
                  maxLength="14"
                />
              </div>
              <div className="cust-field full">
                <label className="cust-label">Razão Social</label>
                <input
                  type="text"
                  name="rzSocial"
                  className="cust-input"
                  onChange={handleChangeRz}
                  value={rzSocial || ""}
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Atividade Principal</label>
                <input
                  type="text"
                  name="mainActivity"
                  className="cust-input"
                  value={mainActivity || ""}
                  maxLength="200"
                  readOnly={true}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Inscrição Estadual</label>
                <input
                  type="text"
                  name="registerState"
                  className="cust-input"
                  value={registerState || ""}
                  maxLength="200"
                  readOnly={true}
                />
              </div>
            </div>
          </div>

          {/* Endereço */}
          <div className="cust-card">
            <div className="cust-section-header">Endereço</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">CEP</label>
                <input
                  type="text"
                  pattern="\d*"
                  name="cep"
                  onChange={handleChangeCEP}
                  className="cust-input"
                  value={address?.cep || ""}
                  maxLength="8"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Estado</label>
                <select
                  className="cust-select"
                  name="state"
                  value={address ? address.state : ""}
                >
                  <option value=""></option>
                  {states
                    ? states.map((item) => (
                        <option key={item.stateId} value={item.stateId}>
                          {item.state}
                        </option>
                      ))
                    : false}
                </select>
              </div>
              <div className="cust-field full">
                <label className="cust-label">Endereço</label>
                <input
                  type="text"
                  name="street"
                  onChange={handleChange}
                  className="cust-input"
                  value={
                    inputs.street !== undefined
                      ? inputs.street
                      : address?.street || ""
                  }
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Número</label>
                <input
                  type="text"
                  name="numAddress"
                  onChange={handleChangeNumAddress}
                  className="cust-input"
                  value={numAddress || ""}
                  maxLength="8"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Complemento</label>
                <input
                  type="text"
                  name="complement"
                  onChange={handleChangeComplement}
                  className="cust-input"
                  value={complement || ""}
                  maxLength="8"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Cidade</label>
                <input
                  type="text"
                  name="city"
                  onChange={handleChange}
                  className="cust-input"
                  defaultValue={address ? address.city : ""}
                  maxLength="8"
                />
              </div>
            </div>
          </div>

          {/* Comercial */}
          <div className="cust-card">
            <div className="cust-section-header">Comercial</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Vendedor(a)</label>
                <select
                  className="cust-select"
                  name="managerBy"
                  id="managerBy"
                  onChange={handleChangeManager}
                  value={managedBy ? managedBy : ""}
                >
                  <option value=""></option>
                  {users
                    ? users.map((item) => (
                        <option key={item.userId} value={item.userId}>
                          {item.name}
                        </option>
                      ))
                    : false}
                </select>
              </div>
              <div className="cust-field">
                <label className="cust-label">Representante</label>
                <select
                  className="cust-select"
                  name="representative"
                  id="representative"
                  onChange={handleChangeRep}
                  value={userRepId ? userRepId : ""}
                >
                  <option value=""></option>
                  {reps
                    ? reps.map((item) => (
                        <option key={item.userRepId} value={item.userRepId}>
                          {item.name}
                        </option>
                      ))
                    : false}
                </select>
              </div>
            </div>
          </div>

          {/* Configurações (admin only) */}
          {currentUser.isAdmin && (
            <div className="cust-card">
              <div className="cust-section-header">Configurações</div>
              <div className="cust-fields">
                <div className="cust-field">
                  <label className="cust-label">Visão dos Preços</label>
                  <select
                    className="cust-select"
                    name="isActive"
                    onChange={handleChangeActive}
                    value={active}
                  >
                    <option value=""></option>
                    <option value="Aprovado">Aprovado</option>
                    <option value="Negado">Negado</option>
                    <option value="Pendente">Pendente</option>
                  </select>
                </div>
                {active === "Negado" && (
                  <div className="cust-field">
                    <label className="cust-label">Motivo do Negado</label>
                    <select
                      className="cust-select"
                      name="reason"
                      onChange={handleChangeReason}
                      value={reason}
                    >
                      <option value=""></option>
                      {rejections
                        ? rejections.map((item) => (
                            <option
                              key={item.customerRejectionId}
                              value={item.customerRejectionId}
                            >
                              {item.rejection}
                            </option>
                          ))
                        : false}
                    </select>
                  </div>
                )}
              </div>
              <div className="cust-fields-2col">
                <div className="cust-field">
                  <label className="cust-label">Meta de Compra</label>
                  <input
                    type="text"
                    name="target"
                    className="cust-input"
                    defaultValue={target ? formatPricing(target) : ""}
                    onChange={handleChangeTarget}
                    onKeyDown={(e) => {
                      if (e.keyCode === 8 || e.keyCode === 46) {
                        setTarget(undefined);
                      }
                    }}
                  />
                </div>
                <div className="cust-field">
                  <label className="cust-label">Campanha</label>
                  <select
                    className="cust-select"
                    name="campaign"
                    id="campaign"
                    onChange={handleChangeCampaign}
                    value={campaign ? campaign : ""}
                  >
                    <option value=""></option>
                    {campaigns
                      ? campaigns.map((item) => (
                          <option key={item.campaignId} value={item.campaignId}>
                            {item.title}
                          </option>
                        ))
                      : false}
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* Outros */}
          <div className="cust-card">
            <div className="cust-section-header">Outros</div>
            <div className="cust-switch-row">
              <span className="cust-label" style={{ marginBottom: 0 }}>
                Estrangeiro
              </span>
              <Switch
                checked={estrangeiro}
                onChange={(e) => handleChangeEstrangeiro(e)}
              />
            </div>
          </div>
          <div className="cust-footer">
            <Button variant="outlined" size="small" onClick={() => nav(-1)}>
              Voltar
            </Button>
            <Button variant="contained" color="secondary" size="small" startIcon={<SaveIcon />} onClick={updateClick}>
              {id !== "new" ? "Alterar" : "Cadastrar"}
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
}
